var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScreensizeFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17781_1830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0902 6.91032L17.0902 10.9691C17.0902 11.6126 17.6099 12.1323 18.2534 12.1323C18.8968 12.1323 19.4165 11.6126 19.4165 10.9691L19.4248 5.73063C19.4248 5.08717 18.9051 4.56744 18.2616 4.56744L13.0231 4.57569C12.3797 4.57569 11.8599 5.09542 11.8599 5.73888C11.8599 6.38235 12.3797 6.90207 13.0231 6.90207L17.0902 6.91032ZM6.91018 17.0903L6.91018 13.0315C6.91018 12.388 6.39046 11.8683 5.74699 11.8683C5.10352 11.8683 4.5838 12.388 4.5838 13.0315L4.57555 18.27C4.57555 18.9135 5.09527 19.4332 5.73874 19.4332L10.969 19.4332C11.6124 19.4332 12.1322 18.9135 12.1322 18.27C12.1322 17.6265 11.6124 17.1068 10.969 17.1068L6.91018 17.0903Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17781_1830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreensizeFull);
export default __webpack_public_path__ + "static/media/screensize-full.01d9da5b1811db2ab773dad8358a8312.svg";
export { ForwardRef as ReactComponent };